import { render, staticRenderFns } from "./ProjectValuationExternalReportPage15.vue?vue&type=template&id=0736d5b7&scoped=true&"
import script from "./ProjectValuationExternalReportPage15.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationExternalReportPage15.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectValuationExternalReportPage15.vue?vue&type=style&index=0&id=0736d5b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0736d5b7",
  null
  
)

export default component.exports